import { deleteApi, get, post } from "../GenericServices";

const CarContract = {
  getCarContracts: (queryString) => {
    return get(`car-contract${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getCarContract: (id) => {
    return get(`car-contract/${id}`);
  },
  setCarContract: (data) => {
    return post(`car-contract`, data);
  },
  deleteCarContract: (id) => {
    return deleteApi(`car-contract/${id}`);
  },
};

export default CarContract;
